import './App.css';
import './utilities.css';
import './modern.css';
import { BrowserRouter, Routes, Route } from "react-router-dom"
import Layout from './components/Navbar'
import Home from './components/Home'
import CalQuote from './components/CalQuote';
import Quotes from './components/Quotes';
import SRdetails from './components/SRdetails';
import { QuoteProvider } from './assets/context/QuoteContext';
import Review from './components/Review';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import Bookings from './components/Bookings';
import Dashboard from './components/Dashboard';
import Tracking from './components/Tracking';
import Login from './components/Login';
import { AuthProvider } from './assets/context/AuthContext';
import AdminLogin from './components/AdminLogin';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import NotFound from './components/NotFound';
import ContentPage from './components/ContentPage';
import BusinessPasswordChange from './components/BusinessPasswordChange';
import AccountSettings from './components/AccountSettings';

const stripePromise = loadStripe('pk_test_51R3D2i1W0wwPHZ9tS4U8bGcGK3QY6zgyNXEPo7fikkSAj52gdm1tkeSt0GOskvtATY9Xn9H3OETjadLltpncz4j500GYVX6hmc');

function App() {
  return (
    <AuthProvider>
    <Elements stripe={stripePromise}>
      <QuoteProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              {/* <Route path="about" element={<About />} /> */}
              <Route path="CalQuote" element={<CalQuote />} />
              <Route path="Quotes" element={<Quotes />} />
              <Route path="SRdetails" element={<SRdetails />} />
              <Route path="Review" element={<Review />} />
              <Route path="Bookings" element={<Bookings />} />
              <Route path="Dashboard" element={<Dashboard />} />
              <Route path="Tracking" element={<Tracking />} />
              <Route path="Login" element={<Login />} />
              <Route path="AdminLogin" element={<AdminLogin />} />
              <Route path="ForgotPassword" element={<ForgotPassword />} />
              <Route path="ResetPassword" element={<ResetPassword />} />
              <Route path="BusinessPasswordChange" element={<BusinessPasswordChange />} />
              <Route path="account" element={<AccountSettings />} />
              <Route path="faq" element={<ContentPage slug="faq" />} />
              <Route path="terms" element={<ContentPage slug="terms" />} />
              <Route path="privacy" element={<ContentPage slug="privacy" />} />
              <Route path="*" element={<NotFound />} />
              
              
              
              {/* <Route path="signup" element={<Signup />} /> */}
            </Route>
          </Routes>
        </BrowserRouter>
      </QuoteProvider>
    </Elements>
    </AuthProvider>
  );
}

export default App;
